enum LayerMappingsEnum {
    Default = 0,
    DebugEntities = 1,
    Stage = 2,
    Hidden,
    ReferenceLine,

    Elements2d, // Layer for most 2D elements
    Elements3d, // Layer for most 3D elements

    Spaces2d,   // Layer for 2D spaces
    Spaces3d,
    RoomNameLabels,
    DoorSymbols,
    WindowSymbols, // Layer for 2D symbols
    FillingShapes,
    Fixtures2d,
    Fixtures3d,
    FloorCoverings2d,
    FloorCoverings3d,
    FloorCoverings3dNoTexture,
    WallCoverings2d,
    WallCoverings3d,
    WallCoverings3dNoTexture,
    CeilingCoverings2d,
    CeilingCoverings3d,
    CeilingCoverings3dNoTexture,
    Skirtings2d,
    Skirtings3d,
    StoreyNames2d,
    Annotations,
    Annotations2d,
    Annotations3d,
};

export default LayerMappingsEnum;